type RouterHistoryState = { idx?: unknown } & Record<string, unknown>;

/**
 * Puts the data router's `idx` back on the current history entry after login.
 *
 * `tempus-okta-client` `authorize()` (plus t-shared `decodeURL` / `setupImpersonation`) call
 * `history.replaceState(null, …)` after the router stamps the landing entry. Without `idx`,
 * `useBlocker` cannot hold a browser Back press that returns to that entry, so leave guards fail open.
 */
export function restoreRouterHistoryIndex(snapshot: unknown): void {
  const saved = snapshot as RouterHistoryState | null;
  if (typeof saved?.idx !== 'number') {
    return;
  }
  const current = window.history.state as RouterHistoryState | null;
  if (typeof current?.idx === 'number') {
    return;
  }
  window.history.replaceState({ ...saved, ...current, idx: saved.idx }, '');
}
